import React from 'react';

const Work = () => {
    // Your Projects Data
    const projects = [
        {
            id: 1,
            title: "Gym SaaS Platform",
            desc: "Full business management for trainers.",
            tech: ["MERN", "Stripe", "Redux"],
            // Image: A gym setting with a tech vibe
            image: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?q=80&w=1470&auto=format&fit=crop",
            size: "col-span-1 md:col-span-2 row-span-2", // BIG BOX
            link: "https://topfitness-mu.vercel.app"
        },
        {
            id: 2,
            title: "Ice Cream Logistics",
            desc: "Inventory & Sales tracking system.",
            tech: ["React", "Node", "JWT"],
            // Image: A modern, colorful ice cream shop counter
            image: "https://images.unsplash.com/photo-1501443762994-82bd5dace89a?q=80&w=2070&auto=format&fit=crop",
            size: "col-span-1 md:col-span-1 row-span-1", // SMALL BOX
            link: "https://jatra-theta.vercel.app/"
        },
        {
            id: 3,
            title: "Salon Management",
            desc: "High-performance backend architecture.",
            tech: ["Node.js", "Express", "Redis"],
            // Image: A luxury salon interior
            image: "https://assets.onemusic.com.au/images/transforms/Photos/Hair-and-Beauty/_500x334_crop_center-center_line/salon-body.png",
            size: "col-span-1 md:col-span-1 row-span-1", // SMALL BOX
            link: "https://salon-ecru.vercel.app/"
        }
    ];

    return (
        <section className="bg-void py-24 relative">
            
            {/* Background Grid */}
            <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px] pointer-events-none" />

            <div className="container mx-auto px-6 relative z-10">
                
                {/* Section Header */}
                <div className="flex flex-col md:flex-row justify-between items-end mb-12 border-b border-white/10 pb-6">
                    <div>
                        <span className="text-neon-blue font-mono text-sm tracking-widest uppercase mb-2 block">
                            // Case Studies
                        </span>
                        <h2 className="text-4xl md:text-5xl font-black text-white font-display">
                            SELECTED WORKS
                        </h2>
                    </div>
                    {/* Desktop "View All" Link */}
                    <a href="/work" className="hidden md:flex items-center gap-2 text-gray-400 hover:text-white transition-colors group">
                        View Full Archive 
                        <span className="group-hover:translate-x-1 transition-transform">→</span>
                    </a>
                </div>

                {/* --- THE BENTO GRID --- */}
                <div className="flex flex-col gap-6 md:grid md:grid-cols-3 md:auto-rows-[300px]">
                    
                    {projects.map((project) => (
                        <a 
                            key={project.id} 
                            href={project.link}
                            target="_blank" 
                            rel="noopener noreferrer"
                            className={`group relative overflow-hidden bg-surface border border-white/5 hover:border-neon-blue/50 transition-all duration-500 ${project.size} min-h-[300px] cursor-pointer block`}
                        >
                            {/* Image Background */}
                            <div className="absolute inset-0">
                                <img 
                                    src={project.image} 
                                    alt={project.title} 
                                    className="w-full h-full object-cover opacity-60 group-hover:opacity-40 group-hover:scale-105 transition-all duration-700 grayscale group-hover:grayscale-0"
                                />
                                {/* Gradient Overlay to make text readable */}
                                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" />
                            </div>

                            {/* Content (Positioned at bottom) */}
                            <div className="absolute bottom-0 left-0 p-6 w-full transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                                
                                {/* Tech Chips */}
                                <div className="flex gap-2 mb-3">
                                    {project.tech.map(t => (
                                        <span key={t} className="text-[10px] font-mono border border-white/20 bg-black/50 px-2 py-1 text-gray-300 uppercase backdrop-blur-sm">
                                            {t}
                                        </span>
                                    ))}
                                </div>

                                <h3 className="text-2xl font-bold text-white mb-1 font-display">
                                    {project.title}
                                </h3>
                                <p className="text-gray-400 text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300 delay-75">
                                    {project.desc}
                                </p>
                            </div>

                            {/* Hover Arrow Icon (Top Right) */}
                            <div className="absolute top-6 right-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                <div className="bg-neon-blue text-black p-2 rounded-full">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-4 h-4">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25" />
                                    </svg>
                                </div>
                            </div>

                        </a>
                    ))}

                    {/* "More Work" Box (Only visible on Desktop Grid) */}
                    <a href="/work" className="hidden md:flex flex-col justify-center items-center bg-transparent border border-white/10 border-dashed hover:bg-white/5 transition-colors cursor-pointer group">
                        <div className="w-12 h-12 rounded-full border border-white/20 flex items-center justify-center mb-4 group-hover:border-neon-blue group-hover:text-neon-blue transition-colors">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-gray-400 group-hover:text-neon-blue">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                            </svg>
                        </div>
                        <span className="text-gray-400 font-mono text-sm group-hover:text-white">View All Projects</span>
                    </a>

                </div>

            </div>
        </section>
    );
};

export default Work;